const USER_ID = "Ujf831-w7ZGILm0bM";
const SERVICE_ID = "service_qgt5m3q";
const TEMPLATE_ID = "lbs-contact_form0001";

export { USER_ID, SERVICE_ID, TEMPLATE_ID };
